import { FinancialWellnessArticle } from "../models/dashboard/financial-wellness-articles";
import { get } from "../repositories/participant";

export async function getFinancialWellnessResource(): Promise<
  FinancialWellnessArticle[]
> {
  return get(`/retirement/v1/content/links`);
}
